import fieldTypes from '../../../../../../enums/FieldTypes';
import {onlyBillingAddresses, onlyDeliveryAddresses} from '../../addressFormType';
import addressee from '../../defaultFieldDefinitions/Addressee';
import townCity from '../../defaultFieldDefinitions/TownCity';
import {usZipcodeFilter} from '../../fieldFilters/usZipcodeFilter';
import formatTrimToUpper from '../../formatTrimToUpper';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import validateAutocompleteField from '../../validateAutocompleteField';
import usZipcode from '../../validationByCountry/US/us-zipcode';

const states = PredictionsByField.county('US');

const FieldDefinitionUSDefault = [
  addressee,
  {
    name: 'streetName',
    label: 'checkout.address.field.label.address.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 35,
    validate: [required.address1, max.lengthAddress(35)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.houseNameOrNumber.text',
    filterCondition: onlyDeliveryAddresses,
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
  {
    name: 'streetName',
    label: 'checkout.address.field.label.address1.text',
    filterCondition: onlyBillingAddresses,
    required: true,
    maxLength: 35,
    validate: [required.address1, max.lengthAddress(35)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.address2.text',
    filterCondition: onlyBillingAddresses,
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
  townCity,
  {
    name: 'county',
    label: 'checkout.delivery.address.field.label.state.text',
    element: 'select',
    required: true,
    validate: [required.state, max.lengthAddress(35)],
    options: [
      {value: 'AA', content: 'AA - Armed Forces Americas'},
      {value: 'AE', content: 'AE - Armed Forces other'},
      {value: 'AP', content: 'AP - Armed Forces Pacific'},
      {value: 'AL', content: 'AL - Alabama'},
      {value: 'AK', content: 'AK - Alaska'},
      {value: 'AZ', content: 'AZ - Arizona'},
      {value: 'AR', content: 'AR - Arkansas'},
      {value: 'CA', content: 'CA - California'},
      {value: 'CO', content: 'CO - Colorado'},
      {value: 'CT', content: 'CT - Connecticut'},
      {value: 'DC', content: 'DC - District of Columbia'},
      {value: 'DE', content: 'DE - Delaware'},
      {value: 'FL', content: 'FL - Florida'},
      {value: 'GA', content: 'GA - Georgia'},
      {value: 'HI', content: 'HI - Hawaii'},
      {value: 'ID', content: 'ID - Idaho'},
      {value: 'IL', content: 'IL - Illinois'},
      {value: 'IN', content: 'IN - Indiana'},
      {value: 'IA', content: 'IA - Iowa'},
      {value: 'KS', content: 'KS - Kansas'},
      {value: 'KY', content: 'KY - Kentucky'},
      {value: 'LA', content: 'LA - Louisiana'},
      {value: 'ME', content: 'ME - Maine'},
      {value: 'MD', content: 'MD - Maryland'},
      {value: 'MA', content: 'MA - Massachusetts'},
      {value: 'MI', content: 'MI - Michigan'},
      {value: 'MN', content: 'MN - Minnesota'},
      {value: 'MS', content: 'MS - Mississippi'},
      {value: 'MO', content: 'MO - Missouri'},
      {value: 'MT', content: 'MT - Montana'},
      {value: 'NE', content: 'NE - Nebraska'},
      {value: 'NV', content: 'NV - Nevada'},
      {value: 'NH', content: 'NH - New Hampshire'},
      {value: 'NJ', content: 'NJ - New Jersey'},
      {value: 'NM', content: 'NM - New Mexico'},
      {value: 'NY', content: 'NY - New York'},
      {value: 'NC', content: 'NC - North Carolina'},
      {value: 'ND', content: 'ND - North Dakota'},
      {value: 'OH', content: 'OH - Ohio'},
      {value: 'OK', content: 'OK - Oklahoma'},
      {value: 'OR', content: 'OR - Oregon'},
      {value: 'PA', content: 'PA - Pennsylvania'},
      {value: 'PR', content: 'PR - Puerto Rico'},
      {value: 'RI', content: 'RI - Rhode Island'},
      {value: 'SC', content: 'SC - South Carolina'},
      {value: 'SD', content: 'SD - South Dakota'},
      {value: 'TN', content: 'TN - Tennessee'},
      {value: 'TX', content: 'TX - Texas'},
      {value: 'UT', content: 'UT - Utah'},
      {value: 'VT', content: 'VT - Vermont'},
      {value: 'VA', content: 'VA - Virginia'},
      {value: 'WA', content: 'WA - Washington'},
      {value: 'WV', content: 'WV - West Virginia'},
      {value: 'WI', content: 'WI - Wisconsin'},
      {value: 'WY', content: 'WY - Wyoming'},
    ],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatTrimToUpper,
    maxLength: 10,
    inputMode: 'numeric',
    filtersAndFormat: [usZipcodeFilter],
    validate: [required.postCode, max.lengthPostCode(10), usZipcode],
  },
];

const FieldDefinitionUSDefaultWithStateAutocomplete = [
  addressee,
  {
    name: 'streetName',
    label: 'checkout.address.field.label.address.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 35,
    validate: [required.address1, max.lengthAddress(35)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.houseNameOrNumber.text',
    filterCondition: onlyDeliveryAddresses,
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
  {
    name: 'streetName',
    label: 'checkout.address.field.label.address1.text',
    filterCondition: onlyBillingAddresses,
    required: true,
    maxLength: 35,
    validate: [required.address1, max.lengthAddress(35)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.address2.text',
    filterCondition: onlyBillingAddresses,
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: states,
    validate: [required.state, validateAutocompleteField(states, 'state')],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatTrimToUpper,
    maxLength: 10,
    inputMode: 'numeric',
    filtersAndFormat: [usZipcodeFilter],
    validate: [required.postCode, max.lengthPostCode(10), usZipcode],
  },
];

const autocompleteConditions = window.start.settings.should_use_autocomplete_for_state;
const FieldDefinitionUS = autocompleteConditions ? FieldDefinitionUSDefaultWithStateAutocomplete : FieldDefinitionUSDefault;

export default FieldDefinitionUS;
